import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-toastify";
import PermissionList from "./PermissionList";
import { updateRole } from "../../services/rolServices";

export default function AddPermissionToRol({ roles, refreshRoles, defaultSelectedRoleId }) {
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [roleName, setRoleName] = useState("");
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    if (defaultSelectedRoleId) {
      setSelectedRoleId(defaultSelectedRoleId);
      const role = roles.find((r) => r.id === defaultSelectedRoleId);
      if (role) setRoleName(role.name);
    }
  }, [defaultSelectedRoleId, roles]);

  const handleChangeRole = (event) => {
    const roleId = event.target.value;
    setSelectedRoleId(roleId);
    const role = roles.find((r) => r.id === roleId);
    setRoleName(role ? role.name : "");
    setEditing(false); // salir del modo edición al cambiar rol
  };

  const handleSaveRoleName = async () => {
    if (!selectedRoleId) return;
    if (!roleName.trim()) {
      toast.error("El nombre del rol no puede estar vacío");
      return;
    }

    try {
      await updateRole(selectedRoleId, { name: roleName.trim() });
      toast.success("Nombre del rol actualizado");
      refreshRoles();
      setEditing(false);
    } catch (error) {
      toast.error("Error al actualizar el nombre del rol");
    }
  };

  return (
    <Box sx={{ mt: 4 }}>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel id="role-select-label">Seleccionar rol</InputLabel>
        <Select
          labelId="role-select-label"
          value={selectedRoleId}
          onChange={handleChangeRole}
          renderValue={(selected) => {
            const role = roles.find((r) => r.id === selected);
            return role ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {role.name}
                <IconButton size="small" onClick={() => setEditing(true)}>
                  <EditIcon fontSize="small" />
                </IconButton>
              </Box>
            ) : null;
          }}
        >
          {roles.map((role) => (
            <MenuItem key={role.id} value={role.id}>
              {role.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Campo inline para editar el nombre */}
      {selectedRoleId && editing && (
        <Box sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}>
          <TextField
            label="Nombre del rol"
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
            size="small"
          />
          <Button variant="contained" onClick={handleSaveRoleName}>
            Guardar
          </Button>
          <Button variant="outlined" onClick={() => setEditing(false)}>
            Cancelar
          </Button>
        </Box>
      )}

      {selectedRoleId && <PermissionList selectedRoleId={selectedRoleId} />}
    </Box>
  );
}
